App.EventAttendeeTable = class extends App.DataTable {
  constructor(table) {

    const eventIdParamResults = new RegExp('[\?&]' + 'event_id' + '=([^&#]*)').exec(window.location.href);
    const eventId = eventIdParamResults ? eventIdParamResults[1] : false;
    const dataSourceUrl = !!eventId === true ?  `/event_attendees/data_table?event_id=${eventId}`: '/event_attendees/data_table';

    const columns = [
      {
        sortable: false,
        render: function ( data, type, full, meta ) {
          var editLink = "/event_attendees/" + full.id + "/edit";
          return '<a href="'+editLink+'" class="btn btn-xs btn-muted-blue" >Edit</a>';
        },
        width: '48px'
      },
      {
        data: "created_at",
        className: 'sorting_disabled',
        width: '150px',
      },
      {
        data: "first_name",
        className: 'all',
        width: '120px',
        orderable: true
      },
      {
        data: "last_name",
        className: 'all',
        width: '120px'
      },
      {
        data: "job_title",
        className: 'all',
        width: '120px',
        orderable: true
      },
      {
        data: "event_name",
        className: 'all',
        width: '120px',
        render: function(data, type, full, meta) {
          return `<a href="${full.link_to_edit_event}">${data}</a><p>(${full.event_date})</p>`;
        }
      },
      {
        data: "status",
        className: 'all',
        width: '120px',
        orderable: true
      },
      {
        data: "organization",
        className: 'all',
        width: '120px',
      },
      {
        data: "attended",
        className: 'text-center',
        width: '120px',
        sortable: false
      }
    ];

    var searchFilterHtml = {
      'filter-date-registered': "<input type='text' class='form-control input-sm filter-text' placeholder='mm/dd/yyyy' name='filter-date-registered-input' id='filter-date-registered-input' />"
    };

    super({
      table: table,
      dataSourceUrl: dataSourceUrl,
      columns: columns,
      searchFilterHtml: searchFilterHtml,
      initialOrder: [[1, "desc"]]
    });


  }

  /**
   * Initialize the datatable to only display the events with a Status column of "Enabled"
   */
  setupInitialTable() {
    // Execute the filter only if the column in the table has a class of "select-filter"
    if($("#filter-status").hasClass("select-filter")) {
      $("#event_attendee_list").DataTable().column('status:name').search('Enabled').draw();
    }
  }

  afterDataLoad(e, settings, json, xhr) {
  }

  /**
   * Initialize the datatable to query the server for data with the columns in order
   */
  setupTableEvents() {
    /**
     * Search member list by permissions
     */
    var searchPermissions = function() {
      var permissionFields = $('#permissions_search_container select, #permissions_search_container input')
      var permissionParams = '?' + permissionFields.serialize();

      // reload datatable with new params
      $('#event_attendee_list')
        .DataTable()
        .ajax
        .url( permissionParams )
        .load();

      return false;
    }

    // Add events to table rows
    // this.table.find('tbody').on('click', 'tr', clickRow.bind(this));

    // Add events to permission search
    $('button#search_permissions').on('click', searchPermissions);

    this.table.on('xhr.dt', this.afterDataLoad.bind(this));
  }
}

$(document).on('turbo:load', function() {
  if($(".event_attendees.index").length == 0) return;

  var eventAttendeeTable = new App.EventAttendeeTable($("#event_attendee_list"));
  eventAttendeeTable.render();
  eventAttendeeTable.setupInitialTable();
  eventAttendeeTable.setupTableEvents();

  $(document).on("ajax:success", "[data-behavior~=attendee_toggle_attendance_link]", function(event) {
    const [data, status, xhr] = event.detail;
    const eventAttendeeTable = $('#event_attendee_list').DataTable();
    let link_row = $(this).parents("tr");
    eventAttendeeTable.row(link_row).data(data);
  });
});